import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import UpcomingTripCard from './components/UpcomingTripCard';
import BookingStatusCard from './components/BookingStatusCard';
import RecommendationCard from './components/RecommendationCard';
import TravelStatsCard from './components/TravelStatsCard';
import QuickActionsCard from './components/QuickActionsCard';
import NotificationPanel from './components/NotificationPanel';

const UserDashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [upcomingTrips, setUpcomingTrips] = useState([]);
  const [recentBookings, setRecentBookings] = useState([]);
  const [recommendations, setRecommendations] = useState([]);
  const [travelStats, setTravelStats] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeDashboard = async () => {
      try {
        // Simulate API calls with mock data
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Mock user data
        const storedUser = localStorage.getItem('user');
let userData = {
  id: '1',
  name: 'Guest',
  email: 'guest@email.com',
  avatar: 'default-avatar.png',
  memberSince: '2024-01-01',
  loyaltyTier: 'Basic'
};

if (storedUser) {
  const parsed = JSON.parse(storedUser);
  userData = {
    id: '1',
    name: parsed.name || 'Guest',
    email: parsed.email || 'guest@email.com',
    avatar: parsed.avatar || 'default-avatar.png',
    memberSince: parsed.memberSince || '2024-01-01',
    loyaltyTier: parsed.loyaltyTier || 'Basic'
  };
}

setUser(userData);


        // Mock upcoming trips
        const upcomingTripsData = [
          {
            id: '1',
            destination: 'Ooty Hill Station',
            location: 'Tamil Nadu',
            duration: '3 Days 2 Nights',
            packageType: 'Honeymoon Special',
            startDate: '2025-08-15',
            travelers: 2,
            status: 'Confirmed',
            image: 'https://www.trawell.in/blog/wp-content/uploads/2024/03/ooty-main-730x410.jpg'
          }
        ];

        // Mock recent bookings
        const recentBookingsData = [
          {
            id: '1',
            bookingId: 'DT2025001',
            destination: 'Kodaikanal Lake Resort',
            travelDate: '2025-08-15',
            bookingDate: '2025-07-01',
            amount: 25000,
            status: 'confirmed',
            progress: 85
          },
          {
            id: '2',
            bookingId: 'DT2025002',
            destination: 'Munnar Tea Gardens',
            travelDate: '2025-09-10',
            bookingDate: '2025-07-10',
            amount: 18500,
            status: 'processing',
            progress: 45
          },
          {
            id: '3',
            bookingId: 'DT2025003',
            destination: 'Rameswaram Temple Tour',
            travelDate: '2025-07-20',
            bookingDate: '2025-06-15',
            amount: 12000,
            status: 'completed',
            progress: 100
          }
        ];

        // Mock recommendations
        const recommendationsData = [
          {
            id: '1',
            title: 'Coorg Coffee Plantation Tour',
            description: 'Experience the aromatic coffee plantations and scenic beauty of Coorg with guided tours and local cuisine.',
            location: 'Karnataka',
            duration: '4 Days',
            price: 22000,
            rating: 4.8,
            category: 'Nature',
            matchScore: 92,
            image: 'https://masalachilli.com/wp-content/uploads/2018/01/coffee-plantation-scaled.jpg'
          },
          {
            id: '2',
            title: 'Alleppey Backwater Cruise',
            description: 'Sail through the serene backwaters of Kerala in traditional houseboats with authentic meals.',
            location: 'Kerala',
            duration: '2 Days',
            price: 15000,
            rating: 4.9,
            category: 'Adventure',
            matchScore: 88,
            image: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=400&h=300&fit=crop'
          },
          {
            id: '3',
            title: 'Hampi Heritage Walk',
            description: 'Explore the ancient ruins and UNESCO World Heritage sites of Hampi with expert guides.',
            location: 'Karnataka',
            duration: '3 Days',
            price: 12000,
            rating: 4.7,
            category: 'Heritage',
            matchScore: 85,
            image: 'https://www.holidaymonk.com/wp-content/uploads/2024/07/Interesting-things-to-do-in-Hampi.webp'
          },
          {
            id: '4',
            title: 'Golden Temple',
            description: 'One of the most spiritually significant sites in Sikhism and a major pilgrimage destination.',
            location: 'Punjab',
            duration: '4 Days',
            price: 18000,
            rating: 4.5,
            category: 'Heritage',
            matchScore: 80,
            image: 'https://images.travelandleisureasia.com/wp-content/uploads/sites/2/2019/11/golden-temple-feature.jpg?tr=w-1200,q-60'
          },
          {
            id: '5',
            title: 'Dhanushkodi Beach',
            description: ' Dhanushkodi is considered the last land point of India, where the Bay of Bengal and the Indian Ocean meet.',
            location: 'Tamil Nadu',
            duration: '2 Days',
            price: 4000,
            rating: 4.8,
            category: 'Historical',
            matchScore: 87,
            image: 'https://elements-resized.envatousercontent.com/elements-video-cover-images/files/dc76eab2-3e43-4e91-8fcf-06569858b3d7/inline_image_preview.jpg?w=500&cf_fit=cover&q=85&format=auto&s=65b9ae54e53189201750bf671d5570eca70eaf582d70fec2dee53207b8fed8eb'
          },
          {
            id: '6',
            title: 'Tiruvannamalai Temple ',
            description: 'It is especially famous for the Annamalaiyar Temple, dedicated to Lord Shiva. ',
            location: 'Tamil Nadu',
            duration: '1 Day',
            price: 1000,
            rating: 5.0,
            category: 'Spritual',
            matchScore: 89,
            image: 'https://tntemplesproject.in/wp-content/uploads/2021/11/tiruvannamalai-aerial.jpg?w=600'
          },
          {
            id: '7',
            title: 'Thiruvalluvar Statue',
            description: 'It is located on a small island rock near Kanyakumari, Tamil Nadu, India, where the Arabian Sea, Bay of Bengal, and Indian Ocean meet.',
            location: 'Tamil Nadu',
            duration: '2 Days',
            price: 3000,
            rating: 4.4,
            category: 'Historical',
            matchScore: 80,
            image: 'https://www.indica.today/wp-content/uploads/2022/07/Saint-Thiruvalluvar-Statue-image.jpg'
          }
        ];

        // Mock travel statistics
        const travelStatsData = {
          totalTrips: 12,
          favoriteDestinations: 8,
          loyaltyPoints: 7500,
          savedAmount: 45000
        };

        // Mock notifications
        const notificationsData = [
          {
            id: '1',
            type: 'booking',
            title: 'Booking Confirmed',
            message: 'Your Ooty trip booking has been confirmed. Check your email for details.',
            timestamp: new Date(Date.now() - 300000),
            read: false
          },
          {
            id: '2',
            type: 'payment',
            title: 'Payment Successful',
            message: 'Payment of ₹25,000 for Kodaikanal package has been processed successfully.',
            timestamp: new Date(Date.now() - 3600000),
            read: false
          },
          {
            id: '3',
            type: 'travel',
            title: 'Travel Reminder',
            message: 'Your trip to Ooty starts in 3 days. Don\'t forget to pack your essentials!',
            timestamp: new Date(Date.now() - 7200000),
            read: true
          },
          {
            id: '4',
            type: 'system',
            title: 'Profile Update',
            message: 'Your travel preferences have been updated successfully.',
            timestamp: new Date(Date.now() - 86400000),
            read: true
          }
        ];

        setUser(userData);
        setUpcomingTrips(upcomingTripsData);
        setRecentBookings(recentBookingsData);
        setRecommendations(recommendationsData);
        setTravelStats(travelStatsData);
        setNotifications(notificationsData);
      } catch (error) {
        console.error('Error loading dashboard data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeDashboard();
  }, []);

  const handleViewTripDetails = (tripId) => {
    console.log('Viewing trip details for:', tripId);
    // Navigate to trip details page
  };

  const handleDownloadTicket = (tripId) => {
    console.log('Downloading ticket for:', tripId);
    // Implement ticket download
  };

  const handleContactSupport = (tripId) => {
    navigate('/real-time-customer-support');
  };

  const handleViewBookingDetails = (bookingId) => {
    console.log('Viewing booking details for:', bookingId);
    // Navigate to booking details page
  };

  const handleRecommendationInterested = async (recommendationId) => {
    console.log('User interested in recommendation:', recommendationId);
    // Implement ML feedback and navigation to booking
    navigate('/payment-processing');
  };

  const handleRecommendationNotNow = async (recommendationId) => {
    console.log('User not interested in recommendation:', recommendationId);
    // Remove from recommendations and update ML model
    setRecommendations(prev => prev.filter(r => r.id !== recommendationId));
  };

  const handleRebook = () => {
    console.log('Rebooking trip');
    navigate('/payment-processing');
  };

  const handleManageItinerary = () => {
    console.log('Managing itinerary');
    // Navigate to itinerary management
  };

  const handleSubmitReview = () => {
    console.log('Submitting review');
    // Navigate to review submission
  };

  const handleViewProfile = () => {
    console.log('Viewing profile');
    // Navigate to profile management
  };

  const handleMarkNotificationAsRead = (notificationId) => {
    setNotifications(prev => 
      prev.map(n => n.id === notificationId ? { ...n, read: true } : n)
    );
  };

  const handleMarkAllNotificationsAsRead = () => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  };

  const handleDismissNotification = (notificationId) => {
    setNotifications(prev => prev.filter(n => n.id !== notificationId));
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background pt-16">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="flex items-center justify-center h-64">
            <div className="flex flex-col items-center space-y-4">
              <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center animate-pulse">
                <Icon name="Plane" size={24} className="text-primary-foreground" />
              </div>
              <p className="text-muted-foreground font-medium">Loading your dashboard...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background pt-16">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Welcome Header */}
        <div className="mb-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 className="text-3xl font-heading font-bold text-foreground mb-2">
                Welcome back, {user?.name}!
              </h1>
              <p className="text-muted-foreground">
                Ready for your next adventure? Here's what's happening with your travels.
              </p>
            </div>
            <div className="mt-4 sm:mt-0 flex items-center space-x-3">
              <div className="text-right">
                <p className="text-sm font-medium text-foreground">{user?.loyaltyTier} Member</p>
                <p className="text-xs text-muted-foreground">
                  Member since {new Date(user?.memberSince).getFullYear()}
                </p>
              </div>
              <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-primary">
                <img 
                  src={user?.avatar} 
                  alt={user?.name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.src = '/assets/images/no_image.png';
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Main Dashboard Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column - Main Content */}
          <div className="lg:col-span-2 space-y-8">
            {/* Upcoming Trips */}
            {upcomingTrips.length > 0 && (
              <section>
                <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
                  Upcoming Trips
                </h2>
                <div className="grid gap-6">
                  {upcomingTrips.map((trip) => (
                    <UpcomingTripCard
                      key={trip.id}
                      trip={trip}
                      onViewDetails={handleViewTripDetails}
                      onDownloadTicket={handleDownloadTicket}
                      onContactSupport={handleContactSupport}
                    />
                  ))}
                </div>
              </section>
            )}

            {/* Recent Bookings */}
            <section>
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-heading font-semibold text-foreground">
                  Recent Bookings
                </h2>
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="ArrowRight"
                  iconPosition="right"
                  onClick={() => navigate('/payment-processing')}
                >
                  View All
                </Button>
              </div>
              <div className="grid gap-4">
                {recentBookings.map((booking) => (
                  <BookingStatusCard
                    key={booking.id}
                    booking={booking}
                    onViewDetails={handleViewBookingDetails}
                  />
                ))}
              </div>
            </section>

            {/* Travel Statistics */}
            <TravelStatsCard stats={travelStats} />

            {/* Personalized Recommendations */}
            <section>
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h2 className="text-xl font-heading font-semibold text-foreground">
                    Recommended for You
                  </h2>
                  <p className="text-sm text-muted-foreground">
                    Based on your travel history and preferences
                  </p>
                </div>
                <Icon name="Sparkles" size={24} className="text-accent" />
              </div>
              <div className="flex space-x-4 overflow-x-auto pb-4">
                {recommendations.map((recommendation) => (
                  <RecommendationCard
                    key={recommendation.id}
                    recommendation={recommendation}
                    onInterested={handleRecommendationInterested}
                    onNotNow={handleRecommendationNotNow}
                  />
                ))}
              </div>
            </section>
          </div>

          {/* Right Column - Sidebar */}
          <div className="space-y-8">
            {/* Quick Actions */}
            <QuickActionsCard
              onRebook={handleRebook}
              onManageItinerary={handleManageItinerary}
              onSubmitReview={handleSubmitReview}
              onViewProfile={handleViewProfile}
            />

            {/* Notifications */}
            <NotificationPanel
              notifications={notifications}
              onMarkAsRead={handleMarkNotificationAsRead}
              onMarkAllAsRead={handleMarkAllNotificationsAsRead}
              onDismiss={handleDismissNotification}
            />

            {/* Support Widget */}
            <div className="bg-card rounded-xl border border-border p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
                  <Icon name="Headphones" size={20} className="text-success" />
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-foreground">
                    24/7 Support
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    We're here to help
                  </p>
                </div>
              </div>
              <p className="text-sm text-muted-foreground mb-4">
                Need assistance with your bookings or have questions about your trip?
              </p>
              <Button
                variant="outline"
                fullWidth
                iconName="MessageCircle"
                iconPosition="left"
                onClick={() => navigate('/real-time-customer-support')}
              >
                Start Chat
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;